import React from 'react';
import {useMenu} from '../../../../hooks/useMenu';
import ProgressBarView from '../../../views/progressbarView';

function ConcentrationPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Save Matrix"
      content="Saving matrix file..."
      onExit={() => onComponent(null)}
    />
  );
}

export default ConcentrationPB;
